<template>
    <div data-testid="dialog-box-new">
      <!-- <span @click="openDialog(true)">
        <slot name="button" />
      </span> -->
      <v-dialog v-model="value" :max-width="width" scrollable persistent data-testid="dialog-box-new__dialog">
        <v-card :loading="loading" :disabled="loading" loader-height="2" data-testid="dialog-box-new__card">
          <v-card-title class="popupHeader align-center py-1 px-4 border-on" data-testid="dialog-box-new__card-title">
            <span class="font-size-md font-weight-bold" data-testid="dialog-box-new__card-title-text">{{ heading }}</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="openDialog(false)" class="ml-2 " data-testid="dialog-box-new__close-btn"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-actions data-testid="dialog-box-new__card-actions-tabs">
            <slot name="tabs" data-testid="dialog-box-new__tabs" />
          </v-card-actions>
          <v-card-text class="pt-3" data-testid="dialog-box-new__card-text">
            <slot name="body" data-testid="dialog-box-new__body" />
          </v-card-text>
          <v-card-actions >
            <slot name="actions" data-testid="dialog-box-new__actions" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: "DialogBox",
    data: function(){
      return {
        dialog: false,
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      heading: {
        type: String,
        default: "",
      },
      width: {
        type: String,
        default: "",
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    created(){
      this.dialog = this.value;
    },
    activated(){
      this.dialog = this.value;
    },
    methods: {
      openDialog(v) {
        this.$emit("input", v);
        this.$emit("change", v);
      },
    },
    watch: {
      dialog(v) {
        this.openDialog(v);
      },
      value(v) {
        this.dialog = v;
      }
    }
  };
  </script>

  <style lang="scss">
.v-card-text
{
  width: 100%;
  height: 100%;
}
</style>
  